import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Banner from '../components/Banner'

import pic01 from '../assets/images/pic01.jpg'
import pic02 from '../assets/images/pic02.jpg'
import pic03 from '../assets/images/pic03.jpg'
import pic04 from '../assets/images/pic04.jpg'
import pic05 from '../assets/images/pic05.jpg'
import pic06 from '../assets/images/pic06.jpg'

class HomeIndex extends React.Component {
    render() {
        const siteTitle = this.props.data.site.siteMetadata.title
        const siteDescription = this.props.data.site.siteMetadata.description

        return (
            <div>
                <Helmet>
                    <title>{siteTitle}</title>
                    <meta name="description" content={siteDescription} />
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles">
                        <article style={{backgroundImage: `url(${pic01})`}}>
                            <header className="major">
                                <h3>Gatsby-plugin-tawk</h3>
                                <p>A simple plugin to add the Tawk js snippet to all pages of a gatsby site (including this one!)</p>
                            </header>
                            <Link to="/gatsby-tawk" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic02})`}}>
                            <header className="major">
                                <h3>Funny AF Tshirts</h3>
                                <p>A fully functioning Static, Serverless, E-commerce site that uses Gatsby/React on Netlify and Stripe. </p>
                            </header>
                            <Link to="/funnyaftshirts" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic03})`}}>
                            <header className="major">
                                <h3>DemHats</h3>
                                <p>Coming Soon!</p>
                            </header>
                            <Link to="/coming-soon" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic04})`}}>
                            <header className="major">
                                <h3>Homesite</h3>
                                <p>This very site! A Gatsby static site, using netlify hosting and forms.</p>
                            </header>
                            <Link to="/homepage" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic05})`}}>
                            <header className="major">
                                <h3>Coming soon</h3>
                                <p>Build it and they will come</p>
                            </header>
                            <Link to="/coming-soon" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic06})`}}>
                            <header className="major">
                                <h3>Liquid Democracy</h3>
                                <p>A Platform to change the way citizens manage the politicians</p>
                            </header>
                            <Link to="/coming-soon" className="link primary"></Link>
                        </article>
                    </section>
                    <section id="two">
                        <div className="inner">
                            <header className="major">
                                <h2>More about me</h2>
                            </header>
                            <p>When I'm not coding, there's plenty of other life distractions I enjoy. </p>
                            <ul className="actions">
                                <li><Link to="/about" className="button next">More about me</Link></li>
                            </ul>
                        </div>
                    </section>
                </div>

            </div>
        )
    }
}

export default HomeIndex

export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/pages/index.js